import React from "react";
import About from "./about";
import Experience from "./experience";
import DottedScrollSpy from "./dottedScrollSpy";
import PortfolioLanding from "./portfolioLanding";
import FeaturedProject from "./featuredProject";
const Portfolio = () => {
  let items = [
    { title: "Portfolio", href: "#home" },
    { title: "About", href: "#about" },
    { title: "Skills", href: "#skills" },
    { title: "Projects", href: "#projects" },
    { title: "Resume", href: "#resume" },
    { title: "Contact", href: "#contact" },
  ];
  return (
    <div className="portfolio">
      <PortfolioLanding></PortfolioLanding>
      <DottedScrollSpy items={items}></DottedScrollSpy>
      <About></About>
      <Experience></Experience>
      <FeaturedProject></FeaturedProject>
    </div>
  );
};

export default Portfolio;
